import { render, staticRenderFns } from "./CommodityList.vue?vue&type=template&id=01f925c7&scoped=true&"
import script from "./CommodityList.vue?vue&type=script&lang=js&"
export * from "./CommodityList.vue?vue&type=script&lang=js&"
import style0 from "./CommodityList.vue?vue&type=style&index=0&id=01f925c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f925c7",
  null
  
)

export default component.exports